
import { ProductListItem } from "@/models/Product";
import { defineComponent, computed, ref } from "vue";
import LazyImage from "v-lazy-image";
import { useRouter } from "vue-router";
import moment from "moment";
import { useStore } from "@/store";

export default defineComponent({
  components: { LazyImage },
  props: {
    product: {
      type: ProductListItem,
      required: true,
      default: null,
    },
    highlighted: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  async setup(props) {
    const store = useStore();
    const router = useRouter();
    const image = props.product.productImages.find(
      (x) => x.isMainImage
    )?.pathMedium;
    const currentLanguageId = computed(() => store.state.currentLanguageId);

    async function selectProduct() {
      const slot = store.getters.preloadedSlots.slots?.find(
        (x) => x.productId == props.product.id
      );
      router.push({
        name: "productPriceLines",
        params: {
          productId: props.product.id,
          dateStart: moment().format("YYYY-MM-DD"),
          slotId: slot?.id,
        },
      });
    }

    return {
      image,
      selectProduct,
      currentLanguageId,
    };
  },
});
